import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  makeStyles,
} from '@material-ui/core';
import Skeleton from 'components/Skeleton';
import useVerifyPodcastList from 'customHooks/useVerifyPodcastList';
import Pagination from '@material-ui/lab/Pagination';
import noImage from 'images/noImage.jpg';
import { FaSpotify } from 'react-icons/fa';
import { AiFillApple } from 'react-icons/ai';
import {
  acceptPodcastVerify,
  rejectPodcastRequest,
} from 'features/VerifyPodcast/verifyPodcastSlice';
import { imgBaseURL } from '../../apis/Admin';
import { showLoader } from 'utils';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  center: {
    textAlign: 'center',
  },
  end: {
    textAlign: 'end',
  },
  imgWidth: {
    width: '50px',
  },
  acceptRejBtn: {
    padding: '5px',
  },
  container: {
    margin: '1rem',
  },
});

export default function VerifyPodcast() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [callStart, setCallStart] = useState(0);
  const [page, setPage] = React.useState(1);
  const VerifyPodcastList = useVerifyPodcastList(callStart, 10);
  const totalUsers = useSelector(state => state.verifyPodcast.totalList);
  const loader = useSelector(state => state.verifyPodcast.loading);
  const imgUrl = imgBaseURL;
  const totalPages_pre = totalUsers / 10;
  const totalUserPages =
    totalUsers % 10 === 0 ? totalPages_pre : Math.trunc(totalPages_pre) + 1;
  console.log(VerifyPodcastList, 'VerifyPodcastList');

  useEffect(() => {
    setCallStart((page - 1) * 10);
  }, [page]);

  const handlePageChange = value => {
    setPage(value);
  };

  const acceptPodcast = id => {
    const data = {
      podcasts: [id],
    };
    dispatch(acceptPodcastVerify(data));
    history.push('/podcast');
  };
  const rejectPodcast = id => {
    const data = {
      podcasts: [id],
    };
    dispatch(rejectPodcastRequest(data));
    history.push('/podcast');
  };

  return (
    <Skeleton>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TableContainer className={classes.container} component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.center}>Image</TableCell>
                    <TableCell className={classes.center}>User</TableCell>
                    <TableCell className={classes.center}>Title</TableCell>
                    <TableCell className={classes.center}>
                      Description
                    </TableCell>
                    <TableCell className={classes.center}>Spotify</TableCell>
                    <TableCell className={classes.center}>
                      Apple music
                    </TableCell>
                    <TableCell className={classes.center}>Verify</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {VerifyPodcastList.map(podcast => (
                    <TableRow key={podcast._id} className={classes.center}>
                      <TableCell align="center">
                        <img
                          src={
                            podcast.image
                              ? `${imgUrl}/${podcast.image}`
                              : noImage
                          }
                          alt="podcast_image"
                          className={classes.imgWidth}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {podcast.user.userName}
                      </TableCell>
                      <TableCell align="center">{podcast.title}</TableCell>
                      <TableCell align="center">
                        {podcast.description}
                      </TableCell>
                      <TableCell align="center">
                        <FaSpotify
                          size={25}
                          style={{ cursor: 'pointer', color: 'green' }}
                          onClick={() => window.open(podcast.spotifyLink)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <AiFillApple
                          size={25}
                          style={{ cursor: 'pointer', color: 'gray' }}
                          onClick={() => window.open(podcast.appleMusicLink)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Grid container>
                          <Grid xs={6} className={classes.acceptRejBtn}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => acceptPodcast(podcast._id)}
                            >
                              Accept
                            </Button>
                          </Grid>
                          <Grid
                            xs={6}
                            className={classes.acceptRejBtn}
                            onClick={() => rejectPodcast(podcast._id)}
                          >
                            <Button variant="contained" color="secondary">
                              Reject
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div style={{ textAlign: 'center' }}>
                {VerifyPodcastList.length === 0 && 'No Data'}
              </div>
            </TableContainer>
            <div className={classes.pagination}>
              <Pagination
                color="primary"
                count={totalUserPages ? totalUserPages : 0}
                page={page}
                onChange={handlePageChange}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      {showLoader(loader)}
    </Skeleton>
  );
}
